/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
  const mobilePaymentBtn = document.querySelectorAll('.btn-payment-mobile');
  mobilePaymentBtn.forEach(v => {
    v.onclick = () => {
      document.querySelector('.product-option-part').classList.add('visible');
      document.querySelector('.product-popup-cover').classList.add('visible');
    }
  });
})();